import { defineStore } from 'pinia';
import { useAuthStore } from './auth';
import { useEnvsStore } from 'stores/envs';

export interface WebSocketsStateInterface {
  progressBar: {
    show: boolean,
    value: number,
    label: string,
    fileName?: string,
  },
  progressWebSocket: WebSocket | null,
}

export const useWebSocketsStore = defineStore('web-sockets', {
  state: (): WebSocketsStateInterface => ({
    progressBar: {
      show: false,
      value: 0,
      label: '0%',
    },
    progressWebSocket: null,
  }),

  actions: {
    initProgressWebSocket() {
      const authStore = useAuthStore();
      const envStore = useEnvsStore();
      
      if (!authStore.user || !envStore.WS_BASE) {
        console.error('WebSocket initialization failed: user or WS_BASE is not defined');
        return;
      }
      
      this.progressWebSocket = new WebSocket(`${envStore.WS_BASE}progress/?user_uuid=${authStore.user.uuid}&email=${authStore.user.email}`);

      this.progressWebSocket.addEventListener('message', (event) => {
        this.handleProgressWebSocketMessage(event);
      });
    },

    handleProgressWebSocketMessage(event: MessageEvent) {
      const data = JSON.parse(event.data);

      if (data.type === 'send_progress' && ![null, undefined].includes(data.progress)) {
        const roundProgress = Math.round(data.progress);
        this.progressBar.value = roundProgress / 100;

        if (roundProgress === 100) {
          this.progressBar.label = '100%';
        } else {
          setTimeout(() => {
            this.progressBar.label = `${roundProgress}%`;
          }, 100);
        }

        if (!!data.name) {
          this.progressBar.fileName = data.name;
        }
      }
    },

    showProgressBar() {
      this.progressBar.show = true;
    },

    hideProgressBar() {
      this.progressBar.show = false;
      this.progressBar.value = 0;
      this.progressBar.label = '0%';
      this.progressBar.fileName = '';
    }
  }
});
